import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import StandardModal, {ModalButtonType, ModalSize} from '../../Fundamentals/Modal/StandardModal';
import {RadioButtons} from "../../FormComponents/RadioButtons";
import { TerminationTypes } from "../../../Constants/VON/TerminationTypes";
import {useDispatch, useSelector} from "react-redux";
import commonActions from "../../../Actions/commonActions";
import customerActions from "../../../Actions/customerActions";
import TerminationReasonsActions from "../../../Actions/InternalCustomerAdmin/terminationReasonsActions";
import DatePicker from '../../Fundamentals/DatePicker';
import {bindActionCreators} from "redux";
import {Dropdown} from "../../FormComponents/Dropdown";
import {FormInput} from "../../FormComponents/Input/Input";

const CollaborationTerminationModal = ({ onSubmit }) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (!terminationReasons)
            terminationReasonsActions.getTerminationReasonsForSkynetSalesChannel();
    }, [])

    const [currentReason, setCurrentReason] = useState("");
    const dispatch = useDispatch();
    const terminationReasonsActions = bindActionCreators(TerminationReasonsActions, dispatch);

    const form = useSelector(state => state.CommonReducer.forms?.collaborationTermination);
    const terminationReasons = useSelector(state => state.InternalCustomerAdminReducer.skynetTerminationReasons);
    if (!form || !terminationReasons)
        return <></>;

    const collaboration = form.data.collaboration;
    const termination = form.data.termination;

    const onModalClose = () => {
        dispatch(commonActions.cancelFormEditing("collaborationTermination"));
    }

    const options = termination.availableTerminationOptions.map(option => ({
            type: option.type,
            label: t(`collaborationtermination.${option.name}`),
            value: "" + option.type
        })
    );

    const onChange = (formId, field, value) => {
        dispatch(commonActions.changeMultiFormField(formId, field, value));
    }

    const changeOption = item => {
        onChange(form.id, "option", parseInt(item))
    }

    const onDropdownChange = (value) => {
        setCurrentReason(value)
        onChange(form.id, 'subReason', "")
        onChange(form.id, "reason", value)
    }

    const onSendTermination = () => {
        dispatch(customerActions.sendCollaborationTermination(collaboration.id, form, () => {
            onModalClose();
            onSubmit();
        }));
    }

    return <StandardModal title={t('collaborationtermination.terminate') + " " + collaboration.product} type={ModalButtonType.SEND}
                          onClose={onModalClose} onSubmit={onSendTermination} size={ModalSize.LARGE}>
            <div className="mt-32 mb-32">
                <fieldset className="col-sm-12 mb-0 pl-0">
                    <RadioButtons items={options} onChange={changeOption} value={""+form.data.option} />
                </fieldset>

                <hr/>

                {form.data.option === TerminationTypes.EndCollaborationWithoutTerminatingService ?
                    <div>
                        <p>{t("collaborationtermination.onlyterminatecollaboration")}</p>

                        <DatePicker label={t('collaborationtermination.collaborationenddate')} showTime={false}
                            onChange={value => onChange(form.id, "endDate", value)}
                            value={form.data.endDate}/>
                    </div>
                    :
                    <div>
                        <p>{t("collaborationtermination.terminatecolllaborationandservice")}</p>

                        <fieldset className="col-sm-12 mb-0 pl-0">
                            <div className="form-group required">
                                <Dropdown options={terminationReasons}
                                          placeholder={t("subscriptiontermination.reasondropdown")}
                                          value={form.data.reason}
                                          onChange={onDropdownChange}
                                          label={t("subscriptiontermination.terminationreason")} />
                            </div>
                            {currentReason && terminationReasons.find(r => r.id === currentReason)?.subReasons?.length > 0 &&
                                <div className="form-group">
                                    <Dropdown
                                        options={terminationReasons.find(r => r.id === currentReason)?.subReasons}
                                        placeholder={t("subscriptiontermination.reasondropdown")}
                                        onChange={(value) => onChange(form.id, 'subReason', value)}
                                        allowClear={true}
                                        value={form.data.subReason}
                                        label={t("subscriptiontermination.subterminationreason")} />
                                </div>
                            }
                            <div className="form-group">
                                <FormInput
                                    label={t("common.comment")}
                                    placeholder={t("common.commentplaceholder")}
                                    value={form.data.comment}
                                    readOnly={false}
                                    onChange={(input) => onChange(form.id, "comment", input)}
                                />
                            </div>
                        </fieldset>
                    </div>
                }
            </div>
    </StandardModal>;
};

export default CollaborationTerminationModal;